import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts } from 'app/components/global';
import processRecovery from '../processRecovery';
import controller from './edit-department-procedures-dialog.controller';
import template from './edit-department-procedures-dialog.html';
import changeProcedureConfirmDialog from '../dialog.changeDepartmentProcedureConfirmDialog';


class dialogService {
  getOptions($event, { assessmentId, processes }) {
    return {
      controller,
      controllerAs: 'editDepartmentProceduresDialogVM',
      locals: {
        assessmentId,
        processes
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editDepartmentProceduresDialog', [
  alerts,
  bcpDataService,
  constants,
  processRecovery,
  loaderService,
  ssDialogService,
  changeProcedureConfirmDialog
])
  .service('editDepartmentProceduresDialog', dialogService)
  .name;
